class AboutUsPresenter {
  getHeroSectionContent() {
    return {
      title: "BEHIND THE INNOVATION",
      description:
        "At Tenth Corporation, we grow with our clients. Every challenge they bring sparks a new idea, and every win is something we celebrate together. Their trust and collaboration are what drive our success.",
      backgroundImage: "/assets/images/Aboutbg.jpg",
      styles: {
        section: {
          backgroundSize: "cover",
          backgroundPosition: "center top",
          backgroundRepeat: "no-repeat",
          width: "100%",
          minHeight: "500px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          color: "white",
        },
        overlay: {
          background:
            "linear-gradient(89.77deg, rgba(8,40,8,0.5) 37.58%, rgba(2,72,2,0.5) 71%)",
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 1,
        },
        content: {
          position: "relative",
          zIndex: 2,
          maxWidth: "800px",
          textAlign: "center",
          padding: "20px",
        },
      },
    };
  }

  getIntroductionContent() {
    return {
      quote: "“Where Innovation meets Purpose”",
      description:
        "Since October 2020, Tenth Corp. has been comitted to delivering cutting-edge technological solutions to both the private and government sectors. We specialize in enhancing operational efficiencies and optimizing data management by leveraging system-based-solutions through innovative technology. We focus on providing customized solutions that address the unique needs of our clients, striving to contribute to a more efficient, data-driven future for our country.",
      imageSrc: "/assets/images/Intro.png",
      imageAlt: "About Us",
    };
  }

  getMissionContent() {
    return {
      iconClass: "bi bi-gear-wide-connected",
      title: "Our Mission",
      description:
        "To deliver innovative technological solutions that would empower businesses and government bodies to streamline processes, enhance operational efficiencies, and adapt to a data-driven environment. By supporting the growth and transformation of both sectors, we aim to contribute to the nation's progress and create a future where technology drives success and development.",
    };
  }

  getVisionContent() {
    return {
      iconClass: "bi bi-globe-central-south-asia",
      title: "Our Vision",
      description:
        "To be a leading provider of transformative technological solutions in both the private and public sectors, helping businesses and government bodies achieve systemized processes that drive national progress and contribute to the country’s technological advancement.",
    };
  }

  getMilestones() {
    return [
      {
        year: "2020",
        title: "Establishment of Tenth Corp",
        description:
          "The beginning of our journey to transform the technology landscape. Founded with a vision to deliver innovative solutions and exceptional service to our clients.",
      },
      {
        year: "2021",
        title: "PhilGeps Platinum Membership Approval",
        description:
          "Achieved the highest tier of membership in the Philippine Government Electronic Procurement System, expanding our capabilities to serve government institutions.",
      },
      {
        year: "2024",
        title: "Accredited Vendor of DBP-DCI",
        description:
          "Received official approval as an Accredited Vendor of Development Bank of the Philippines - Data Center, Inc. (DBP-DCI), marking our excellence in service delivery.",
      },
      {
        year: "2024",
        title: "Direct Contracting Agreement with DBP-DCI",
        description:
          "Secured a Direct Contracting Agreement with DBP-DCI for the implementation of a comprehensive HRIS Project, showcasing our trusted expertise.",
      },
    ];
  }
  getMilestones1() {
    return [
      {
        year: "2024",
        title: "HRIS Project with Bureau of Immigration",
        description:
          "Successfully deployed an advanced Human Resource Information System for the Bureau of Immigration (BI), enhancing their organizational efficiency.",
      },
      {
        year: "2024",
        title: "HRIS Project with PS-DBM",
        description:
          "Implemented a custom HRIS solution for the Procurement System - Department of Budget Management (PS-DBM), streamlining their HR processes.",
      },
    ];
  }
}

export default AboutUsPresenter;
